import { IConfig } from './config.interface';
import { BehaviorSubject } from 'rxjs';

const config = <IConfig>Object.assign({}, window['environment']);
export const configurationSubject = new BehaviorSubject<IConfig>(config);

export function resolveEnvironment() {
    const env = configurationSubject.getValue().environment;
    let resolvedEnvironment = '';
    switch (env) {
      case 'prod':
      case '':
        resolvedEnvironment = '';
        break;
      case 'local':
      case 'dev':
      case 'development':
        resolvedEnvironment = 'dev';
        break;
      case 'test':
      case 'tst':
        resolvedEnvironment = 'tst';
        break;
      case 'staging':
      case 'stg':
        resolvedEnvironment = 'stg';
    }
    return resolvedEnvironment;
}

export function resolveServiceUrl() {
  return configurationSubject.getValue().serviceUrl;
}

export function resolveServicePCPUrl() {
  return configurationSubject.getValue().servicePCPUrl;
}

export function resolveServiceMemberUrl() {
  return configurationSubject.getValue().serviceMemberUrl;
}

export function resolveServiceConsumerProfileUrl() {
  return configurationSubject.getValue().serviceConsumerProfileUrl;
}

export function resolveServiceProviderSiteMapAuthUrl() {
  return configurationSubject.getValue().serviceProviderSiteMapAuthUrl;
}

export function resolveAzureMapClientID() {
  return configurationSubject.getValue().azureMapClientID;
}

export function resolveOcpApimSubscriptionKey() {
  return configurationSubject.getValue().ocpApimSubscriptionKey;
}

export function resolveLaunchDarklyKey() {
  return configurationSubject.getValue().launchDarklyKey;
}

export function apiVersion() {
  return configurationSubject.getValue().apiVersion;
}

export function resolveApiKey() {
  return configurationSubject.getValue().apiKey;
}

export function resolvePiwikConfig() {
  const non: string = '263d35f4-35a1-4830-a27f-f2ecf800c107';
  const prod: string = 'cd288dea-4a12-4e05-80fb-24695d6d94ca';
  return {
    containerURL: 'https://upmc.piwik.pro',
    containerId: resolveEnvironment() ? non : prod
  };
}

export function resolveOAuthConfig() {
  const oauth = configurationSubject.getValue().oauth;
  if(sessionStorage.getItem('authority')) {
    oauth.authority = sessionStorage.getItem('authority');
    oauth.client_id = sessionStorage.getItem('client_id');
  }
  return configurationSubject.getValue().oauth;
}

export function resolveApplicationInsights() {
  return configurationSubject.getValue().applicationInsights;
}

